"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolbarSeparator = void 0;
const Toolbar_1 = require("../../Toolbar");
function toolbarSeparator(config) {
    return () => ({
        type: Toolbar_1.TOOLBAR_ITEM_TYPE.separator,
        text: config === null || config === void 0 ? void 0 : config.title,
        isAction: config === null || config === void 0 ? void 0 : config.isAction
    });
}
exports.toolbarSeparator = toolbarSeparator;
//# sourceMappingURL=toolbarSeparator.js.map